import React from 'react'

import styled from '@emotion/styled'
import { Box, Display, DisplayPosition, Image } from '@gousto-internal/citrus-react'

import { TextBlock } from './TextBlock'
import { Tooltip, TooltipVariant, TooltipArrowType } from './Tooltip'
import { EASY_COOKING } from './data'

const Container = styled.div({
  display: 'flex',
  flexDirection: 'row-reverse',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'nowrap',
  alignSelf: 'flex-start',
  marginTop: '40px',

  '@media (min-width: 640px)': {
    flexDirection: 'row',
    marginTop: '24px',
  },
})

const RotatedImage = styled.img({
  width: '181.36px',
  height: '122.12px',
  transform: 'rotate(-12.37deg)',
  position: 'absolute',
  zIndex: 1,
  right: '140px',
  bottom: '190px',

  '@media (max-width: 375px)': {
    right: '50px',
  },
  '@media (max-width: 639px)': {
    right: '70px',
  },
})

const RoundContainer = styled.div({
  width: '260px',
  height: '260px',
  borderRadius: '100%',
  overflow: 'hidden',
  zIndex: 0,
})

export const EasyCookingSection = () => {
  const [tooltipText] = EASY_COOKING.tooltips

  return (
    <Container data-testid="EasyCookingSection">
      <Box display={Display.Flex} position={DisplayPosition.Relative}>
        <RotatedImage src={EASY_COOKING.additionalImageSource} alt="Recipe card preview" />
        <RoundContainer>
          <Image src={EASY_COOKING.imageSource} alt={EASY_COOKING.title} />
        </RoundContainer>
        <Box position={DisplayPosition.Absolute} bottom="15px" left={['-50px', '-30px']}>
          <Tooltip
            text={tooltipText}
            variant={TooltipVariant.DARK}
            arrow={TooltipArrowType.TOP_RIGHT}
          />
        </Box>
      </Box>

      <Box paddingRight={0} paddingH={[0, 8]} minWidth="174px">
        <TextBlock title={EASY_COOKING.title} text={EASY_COOKING.text} />
      </Box>
    </Container>
  )
}
